import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2 round 3: rewritten for Project Explore from the real UI, English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Understanding Permissions & Roles",
    intro: "Each account has one role. The role decides which dashboard opens after you log in.",
    ordered: false,
    steps: [
      <><strong>Students</strong> see My Learning Dashboard with the chapters assigned to them.</>,
      <><strong>Teachers</strong> use the teacher dashboard to manage classes and students, assign chapters and see grades and progress.</>,
      <><strong>School and district administrators</strong> use the admin dashboard: Teachers, Schools, Classes, Roster, Reporting & Analytics and LTI Platforms. They can add teacher accounts.</>,
    ],
    tip: "Roles are set when an account is created: an administrator adds teachers, and teachers add students.",
  },
  es: {
    title: "Permisos y roles",
    intro: "Cada cuenta tiene un rol. El rol decide qué panel se abre después de iniciar sesión.",
    ordered: false,
    steps: [
      <><strong>Los estudiantes</strong> ven Mi panel de aprendizaje con los capítulos que tienen asignados.</>,
      <><strong>Los maestros</strong> usan el panel de maestro para administrar clases y estudiantes, asignar capítulos y ver calificaciones y progreso.</>,
      <><strong>Los administradores de escuela y de distrito</strong> usan el panel de administración: maestros, escuelas, clases, listas, informes y análisis, y plataformas LTI. Pueden agregar cuentas de maestros.</>,
    ],
    tip: "El rol se asigna cuando se crea la cuenta: un administrador agrega a los maestros y los maestros agregan a sus estudiantes.",
  },
};

export default function UnderstandingPermissionsAndRoles() {
  return <HelpArticle text={TEXT} />;
}
